export const HOST_GROUPS = {
  NZ_HEARING: ["www.nz2.quickandeasyhearing.com", "nz2.quickandeasyhearing.com"],
  ENERGY_COMPARE: [
    "www.2022.myenergycompare.com.au",
    "2022.myenergycompare.com.au",
    "www.gs.myenergycompare.com.au",
    "gs.myenergycompare.com.au",
    "www.myenergycompare.com.au",
    "myenergycompare.com.au"
  ],
  BUSINESS_FUNDS: [
    "www.businessfundstoday.net",
    "businessfundstoday.net",
    "biz.businessfundstoday.net",
    "www.biz.businessfundstoday.net",
    "v2.businessfundstoday.net",
    "www.v2.businessfundstoday.net",
    "businessloan.financesolver.co",
    "www.businessloan.financesolver.co",
    "native.financesolver.co",
    "www.native.financesolver.co"
  ],
  MY_SOLAR_COMPARE: [
    "v4.mysolarcompare.com.au",
    "www.v4.mysolarcompare.com.au",
    "aus.mysolarcompare.com.au",
    "www.aus.mysolarcompare.com.au",
    "localsolarquotes.mysolarcompare.com.au",
    "www.localsolarquotes.mysolarcompare.com.au",
    "lsq.mysolarcompare.com.au",
    "www.lsq.mysolarcompare.com.au"
  ]
};